import React from "react";
import ReactDOM from "react-dom";
import * as numeral from 'numeral'

import App from "./App";
import {insertHeader} from './insertHeader';

import "numeral/locales/ru"

// не рендерим шапку если в url есть параметр 'lk2'
const EXTERNAL_LK_ID = 'lk2';
const urlParams = new URLSearchParams(window.location.search);
const source = urlParams.get('source');

if (!source || source !== EXTERNAL_LK_ID) {
  insertHeader();
}

numeral.locale('ru');

ReactDOM.render(<App />, document.getElementById("root"));
